import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { MenuURL, VIPSDataServiceURL, requestOptions } from "../../Constants/GlobalConstant";

const CatalogueButtons = ({
  store_grp,
  divisionID,
  searchParams,
  keyValues,
  catId,
}) => {
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const grp = (store_grp || "").toString().trim();
    const divisionTrim = (divisionID || "").toString().trim();
    if (!grp) return () => { isMounted = false; };

    const fetchForDivision = async (division) => {
      const url = `${VIPSDataServiceURL}/Misc/GetDivisionStoreConfig?divisionID=${encodeURIComponent(division)}&storeGroup=${encodeURIComponent(grp)}&recType=83&key=${encodeURIComponent("RBO PO Filter Button Set")}`;
      try {
        const r = await fetch(url, requestOptions);
        const data = await r.json();
        if (!data) return [];
        const resolvedCatId = (data.field1 ?? data.Field1 ?? "").toString().trim() || undefined;
        const list = [];
        for (let i = 2; i <= 11; i++) {
          const raw = data[`field${i}`] ?? data[`Field${i}`];
          if (!raw) continue;
          const s = raw.toString().trim();
          if (!s) continue;
          try {
            const arr = JSON.parse(s);
            if (Array.isArray(arr) && arr.length >= 2) {
              const [filter, label] = arr;
              if (label && filter)
                list.push({ label, filter, catId: resolvedCatId || catId });
            }
          } catch (_) {}
        }
        return list;
      } catch (_) {
        return [];
      }
    };

    (async () => {
      if (!divisionTrim) {
        // No division specified, skip API calls
        if (isMounted) setButtons([]);
        return;
      }
      
      const divButtons = await fetchForDivision(divisionTrim);
      if (isMounted) {
        if (divButtons.length) {
          setButtons(divButtons);
          return;
        }
        // Only fetch "ALL" if division-specific returned no results
        const allButtons = await fetchForDivision("ALL");
        setButtons(allButtons);
      }
    })();

    return () => { isMounted = false; };
  }, [store_grp, divisionID]);

  const showCat = (
    storeGrp,
    storeGrpDesc,
    intCatID,
    sFilter,
    catKey1,
    catKey2,
    catKey3
  ) => {
    try { window.mblnClickedFilterButton = true; } catch (_) {}
    const winTop = (window.screen.height - 500) / 2;
    const winLeft = (window.screen.width - 825) / 2;
    const windowFeatures = `width=825,height=500,top=${winTop},left=${winLeft},menubar=no,toolbar=no,resizable=yes,scrollbars=yes`;

    const session_id = searchParams?.get?.("session_id") || "";
    const mRevisedPO = 0;

    // Resolve vendor_id from persisted sessionArray (set by OEForm) or URL fallback
    let vendorId = "";
    try {
      const saRaw = localStorage.getItem("sessionArray");
      if (saRaw) {
        const arr = JSON.parse(saRaw);
        if (Array.isArray(arr)) {
          const vItem = arr.find(
            (it) => it && (it.Key === "vendor_id" || it.key === "vendor_id")
          );
          if (vItem && vItem.Value != null) vendorId = String(vItem.Value);
        }
      }
    } catch (_) {}
    if (!vendorId) {
      try { vendorId = searchParams?.get?.("vendor_id") || ""; } catch (_) {}
    }

    const url =
      MenuURL + `/pages/orders/catitems.aspx?store_grp=${encodeURIComponent(storeGrp)}` +
      `&store_grp_desc=${encodeURIComponent(storeGrpDesc ?? "")}` +
      `&key1=${encodeURIComponent(catKey1 ?? "")}` +
      `&key2=${encodeURIComponent(catKey2 ?? "")}` +
      `&key3=${encodeURIComponent(catKey3 ?? "")}` +
      `&group=0&cat_id=${encodeURIComponent(intCatID ?? "")}` +
      `&session_id=${encodeURIComponent(session_id)}` +
      `&vendor_id=${encodeURIComponent(vendorId ?? "")}&select=Y&filter_type=${encodeURIComponent(sFilter ?? "")}` +
      `&RevisedFlag=${mRevisedPO}`;

    const child = window.open(url, "_blank", windowFeatures);
    if (!child) {
      try { window.mblnClickedFilterButton = false; } catch (_) {}
    }
    let closeWatcher;
    try {
      closeWatcher = setInterval(() => {
        if (!child || child.closed) {
          try { window.mblnClickedFilterButton = false; } catch (_) {}
          try { clearInterval(closeWatcher); } catch (_) {}
        }
      }, 500);
    } catch (_) {}
    if (child && typeof child.addEventListener === "function") {
      const installBridge = () => {
        try {
          child.SelectCatRecord = function (sKey1, sKey2, sKey3) {
            try {
              try { window.mblnClickedFilterButton = false; } catch (_) {}
              const rawCid = intCatID ?? catId;
              const cid = rawCid != null && rawCid !== "" ? Number(rawCid) : undefined;
              if (typeof window.onSelectCatKeyValues === "function") {
                window.onSelectCatKeyValues(cid, sKey1, sKey2, sKey3);
              } else {
                const detail = { catId: cid, sKey1, sKey2, sKey3 };
                window.dispatchEvent(new CustomEvent("catalogue:select", { detail }));
              }
            } catch (e) {
              console.error("SelectCatRecord bridge error:", e);
            }
            try {
              if (child.opener && child.opener.$ && child.opener.$.fancybox &&
                  typeof child.opener.$.fancybox.close === "function") {
                child.opener.$.fancybox.close();
              }
            } catch (_) {}
            try { clearInterval(closeWatcher); } catch (_) {}
            try { child.close(); } catch (_) {}
            return false;
          };
        } catch (e) {
          console.error("Failed to install SelectCatRecord bridge:", e);
        }
      };
      try { child.addEventListener("load", installBridge); } catch (_) {}
      installBridge();
    }
  };

  // Render for all store groups; if no buttons, render nothing
  if (!buttons.length) return null;

  const storeGrpDesc = searchParams?.get?.("store_grp_desc") || "";
  const baseK1 = keyValues?.[0] || "";
  const baseK2 = keyValues?.[1] || "";
  const baseK3 = keyValues?.[2] || "";

  return (
    <div style={{ display: "flex", gap: 8, marginBottom: 8, marginLeft: 20, flexWrap: "wrap" }}>
      {buttons.map((btn, idx) => (
        <Button
          key={`${btn.label}-${idx}`}
          
          variant="contained"
          color="primary"
          size="small"
          sx={{ textTransform:   "none" }}
          onMouseDown={(e) => { try { window.mblnClickedFilterButton = true; } catch (_) {} e.preventDefault(); e.stopPropagation(); }}
          onClick={() => {
            // Use latest typed value from focused CAT textbox, aligned by its keyIndex
            let k1 = baseK1, k2 = baseK2, k3 = baseK3;
            try {
              const ae = document.activeElement;
              const isCat = ae && ae.getAttribute && ae.getAttribute("data-cat-prefix") === "CAT";
              if (isCat) {
                const idxRaw = ae.getAttribute("data-cat-key-index");
                const idx = Number(idxRaw);
                const val = ae && "value" in ae ? ae.value : "";
                if (!Number.isNaN(idx)) {
                  // Treat keyIndex as 1-based (1->key1, 2->key2, 3->key3). Fallback: 0->key1
                  if (idx === 1 || idx === 0) k1 = val || "";
                  else if (idx === 2) k2 = val || "";
                  else if (idx === 3) k3 = val || "";
                }
              }
            } catch (_) {}
            showCat(store_grp, storeGrpDesc, btn.catId, btn.filter, k1, k2, k3);
          }}
          title={btn.label}
        >
          {btn.label}
        </Button>
      ))}
    </div>
  );
};

export default CatalogueButtons;
